export default __webpack_public_path__ + "static/media/SobreNos_Historia 1.b4075e3b.svg";